module.exports = __webpack_public_path__ + "static/media/comment.b75ef82c.svg";